import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=5c4979cb&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=5c4979cb&prod&lang=css&"
import style1 from "./Home.vue?vue&type=style&index=1&id=5c4979cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4979cb",
  null
  
)

export default component.exports